// extracted by mini-css-extract-plugin
export default {"label":"AppInputLabel_label__ei5gI","compact":"AppInputLabel_compact__Nal2L","lastChunk":"AppInputLabel_lastChunk__kZSO5","required":"AppInputLabel_required__+APe7"};